import React from 'react'
import { List, Header } from 'semantic-ui-react'
import Countdown from "react-countdown-now"



const About = () => (
    <List divided relaxed ordered>
        <h2><font color="brown">About Dystater</font></h2>
        <p><b>Dystater</b> is a <b>decentralized digital currency</b>, without a central bank or single administrator, that can be sent from user to user on the <b>peer-to-peer dystater network</b> without the need for intermediaries. Transactions are verified by network nodes through cryptography and recorded in a <b>public distributed ledger</b> called a <b>blockchain</b>. Dystaters are created as a <b>reward</b> for a process known as <b>mining</b>. They can be exchanged for other currencies, products, and services. Research produced by the University of Cambridge estimated that in 2017, there were <b>2.9 to 5.8 million</b> unique users using a cryptocurrency wallet, most of them using <b>Bitcoin</b>. Dystater was launched on the 31st of January 2021.</p>

        <h3>Features:</h3>

        <List.Item>
            <i>Coin Type</i>: BTC altcoin
        </List.Item>

        <List.Item>
            <i>Block reward</i>: 39 dystaters
        </List.Item>

        <List.Item>
            <i>Max Cap</i>: 21 000 000 dystaters
        </List.Item>

        <List.Item>
            <i>Block height</i>: > 8000 blocks
        </List.Item>
        <List.Item>
            <i>Difficult</i>: 2
        </List.Item>
        <List.Item>
            <i>Final block date</i>: 2152
        </List.Item>
        <List.Item>
            <i>Final block height</i>: 6930000
        </List.Item>
        <List.Item>
            <i>Block time</i>: 10 Min
        </List.Item>
        <List.Item>
            <i>Min Difficulty</i>: 0x1d00ffff
        </List.Item>
        <List.Item>
            <i>Core i3 block time</i>: 100 Min
        </List.Item>
        <List.Item>
            <i>Listed on a cryptocurrency exchange</i>: Not yet
        </List.Item>

    </List>
)

export default About
